module.exports = __webpack_public_path__ + "static/media/sucker.f975d39b.png";